import React, { memo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../../Redux/hooks";
import { toggleSidebarCollapse } from "../../Redux/reducers/appSlice";

type Props = {
  type: "main" | "study";
};

const SidebarToggle = ({ type }: Props) => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const collapseThreshold = type === "main" ? 2 : 3;

  useEffect(() => {
    const pathName = location.pathname;
    const slashNumbers = pathName.split("/").filter((e) => e !== "").length;
    if (slashNumbers <= collapseThreshold) {
      dispatch(toggleSidebarCollapse(false));
    } else {
      dispatch(toggleSidebarCollapse(true));
    }
    return () => {
      dispatch(toggleSidebarCollapse(false));
    };
  }, [location.pathname, dispatch, collapseThreshold]);

  return <></>;
};

export default memo(SidebarToggle);
